
import Vue from 'vue'
import {Component} from 'vue-property-decorator'
import {Action, Getter, namespace} from 'vuex-class'
import BaseListItemContainer from '@/containers/base/BaseListItemContainer.vue'
import BaseSubNavContainer from '@/containers/base/BaseSubNavContainer.vue'
import {optionsVslim} from '@/config/v-slim-dialog'

const prospectModule = namespace('prospect')
const echangeModule = namespace('echange')

@Component({
  components: {
    BaseSubNavContainer,
    BaseListItemContainer
  }
})
export default class ProspectEchange extends Vue {
  @prospectModule.Getter('prospectGetter') prospect: any
  @prospectModule.Action('getProspectByIdAction') getProspectById: any
  @echangeModule.Action('deleteEchangeAction') deleteEchange: any

  panel = null

  get isAllowToSendSMS() {
    return this.prospect && this.prospect.CODE_REF_PAYS === 'FRA'
  }

  getLabel({NOM, PRENOM, EMAIL, TELEPHONE1, TELEPHONE2}) {
    if (NOM && PRENOM) return `${PRENOM} ${NOM}`
    else if (NOM) return `${NOM}`
    else if (PRENOM) return `${PRENOM}`
    else if (TELEPHONE1) return `${TELEPHONE1}`
    else if (TELEPHONE2) return `${TELEPHONE2}`
    else if (EMAIL) return `${EMAIL}`
  }

  mailBuilderHandler(data: object) {
    this.panel = this.$showPanel({
      component: 'emailBuilderPanel',
      openOn: 'right',
      width: 700,
      keepAlive: false,
      props: {
        prospect: data
      }
    })
  }

  smsBuilderHandler(data: object) {
    this.panel = this.$showPanel({
      component: 'smsBuilderPanel',
      openOn: 'right',
      width: 700,
      keepAlive: false,
      props: {
        prospects: [data]
      }
    })
  }

  async onDelete(id: number) {
    const {ok} = await this.$dialogs.confirm("Confirmez vous la suppression de l'échange ?", optionsVslim)
    if (ok) {
      this.deleteEchange(id).then(async () => {
        await this.getProspectById(this.$route.params.id)
      })
    }
  }
}
